<template>
    <div>
        <div v-if="isPartOfForm"><span>{{ $t('attach-file') }}</span></div>
        <div  :class="[isPartOfForm ? 'w-100' : 'col-lg-7 col-12 p-1']">
            <base-select searchable :loading="tagSelect.loading" :options="tagSelect.options" v-model="tagSelect.value" :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :placeholder="$t('select-file-type')" clearable></base-select>
        </div>
        <div v-if="tagSelect.value">
            <div v-if="showDocumentOrLinkSelector" :class="[isPartOfForm ? 'd-flex justify-content-center' : 'col-lg-7 col-12 p-1']">
                <base-radio-group :options="documentOrLinkOptions" v-model="documentOrLinkValue"></base-radio-group>
            </div>
            <b-form-file :class="['mt-2', isPartOfForm ? 'w-100' : 'col-lg-7 col-12']"
                v-model="file"
                :placeholder="$t('select-or-drag-drop-file')"
                :drop-placeholder="$t('drag-drop-file')"
                :browse-text="$t('browse')"
                @input="uploadFile" v-if="showUploadBox">
            </b-form-file>
            <div v-if="showUploadLinkBox" class="col-12 p-1 mt-2">
                <div class="row">
                    <base-input zeroMarginBottom class="col-12 col-md-5 pr-2 mb-2" :placeholder="$t('name')" v-model="link.name"></base-input>
                    <base-input zeroMarginBottom class="col-12 col-md-5 px-2 mb-2" placeholder="URL (http://...)" v-model="link.url"></base-input>
                    <div class="col-md-2">
                        <base-button @click="uploadLink" class="w-100"><b-icon-plus-lg v-if="isPartOfForm"></b-icon-plus-lg><span v-else>{{ $t('save') }}</span></base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilesRepository from '@/repositories/FilesRepository'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import BaseInput from '@/components/base/forms/BaseInput.vue'
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup.vue'
import { BIcon, BFormFile } from 'bootstrap-vue'
import * as historyDataEs from '@/lang/es/clinic-history.json'
import * as historyDataEn from '@/lang/en/clinic-history.json'
import * as historyDataPt from '@/lang/pt/clinic-history.json'
import { EN_LOCALE, PT_LOCALE } from '@/constants/locales'
import { PRESCRIPTION, LINK_TYPES, LINK_OR_FILE } from '@/constants/db/fileCategories'

const UPLOAD_FROM_DEVICE_TYPE = 0
const UPLOAD_LINK_TYPE = 1
const FILE_TYPE = 'file'
const LINK_TYPE = 'link'

export default {
    components: { BaseButton, BaseInput, BaseRadioGroup, BFormFile, BIcon },
    watch: {
        'tagSelect.value' (value) {
            this.documentOrLinkValue = null
        }
    },
    props: {
        isPartOfForm: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            tagSelect: {
                options: [],
                value: null,
                loading: false,
                filter: null
            },
            file: null,
            documentOrLinkValue: null,
            documentOrLinkOptions: [{text: this.$t('upload-from-device'), value: UPLOAD_FROM_DEVICE_TYPE}, {text: this.$t('insert-url'), value: UPLOAD_LINK_TYPE}],
            link: {
                name: null,
                url: null
            }
        }
    },
    created () {
        if (this.tagSelect.options.length === 0) {
            FilesRepository.getFilesTags().then((response) => {
                let tags = response.data.filter(item => item.id !== PRESCRIPTION)
                tags.push({id: -1, name: {es: historyDataEs.reportOrPrescripcion, en: historyDataEn.reportOrPrescripcion, pt: historyDataPt.reportOrPrescripcion}})
                tags.push({id: -2, name: {es: historyDataEs.dataopensalud, en: historyDataEn.dataopensalud, pt: historyDataPt.dataopensalud}})
                tags.sort((a, b) => this.$i18n.locale === EN_LOCALE ? a.name.en > b.name.en : this.$i18n.locale === PT_LOCALE ? a.name.pt > b.name.pt : a.name.es > b.name.es)
                this.tagSelect.options = tags
            })
        }
    },
    methods: {
        uploadFile () {
            if (!this.isPartOfForm) {
                ClinicHistoryRepository().uploadFileToClinicHistory(this.file, this.tagSelect.value).then((response) => {
                    this.$emit('refresh') // pasaralfilesRepository, hacer la comprobación del badrequest
                })
            } else {
                this.$emit('sendFile', {
                    file: this.file,
                    data: {
                        name: this.file.name,
                        size: this.file.size,
                        type: this.file.type,
                        category: this.tagSelect.options.find(x => x.id === this.tagSelect.value),
                        fileType: FILE_TYPE,
                        url: URL.createObjectURL(this.file)
                    }
                })
            }
            this.resetForm()
        },
        uploadLink () {
            if (!this.link.name) {
                this.$store.dispatch('showDangerAlert', this.$t('link.nameError'))
            } else if (!this.link.url || !this.$validators.validateUrl(this.link.url)) {
                this.$store.dispatch('showDangerAlert', this.$t('link.linkError'))
            } else {
                if (!this.isPartOfForm) {
                    let data = {fileCategory: this.tagSelect.value, link: this.link}
                    ClinicHistoryRepository().saveApps(data).then((response) => {
                        this.$emit('refresh')
                    })
                } else {
                    this.link.category = this.tagSelect.options.find(x => x.id === this.tagSelect.value)
                    this.link.fileType = LINK_TYPE
                    this.$emit('sendFile', {
                        data: this.link
                    })
                }
                this.resetForm()
            }
        },
        resetForm () {
            this.tagSelect.value = null
            this.file = null
            this.link = { name: null, url: null }
        }
    },
    computed: {
        showUploadLinkBox () {
            return LINK_TYPES.includes(this.tagSelect.value) || (this.showDocumentOrLinkSelector && this.documentOrLinkValue === UPLOAD_LINK_TYPE)
        },
        showUploadBox () {
            return (!LINK_TYPES.includes(this.tagSelect.value) && !this.showDocumentOrLinkSelector) || (this.showDocumentOrLinkSelector && this.documentOrLinkValue === UPLOAD_FROM_DEVICE_TYPE)
        },
        showDocumentOrLinkSelector () {
            return LINK_OR_FILE.includes(this.tagSelect.value)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/base/forms/UploadFileSelect.vue